function AIBanner() {
    return null;
}
export default AIBanner;
